/* SABLEAU FORK (TR-port 09-10, store/sableau/tr-port-2026-10/PLAN.md) of the Thighrise cart drawer script. Differences
   (operator review 09-10, store/sableau/tr-port-2026-10/REVIEW-2026-10-09.md):
   - credit text = Thighrise's (account credit, email + one-time code sign-in), rate from the theme setting credit_rate via
     snippets/tr-wallet-data.liquid; every amount, the "back for every 1" included, in the visitor's currency (#9, #24);
   - 15-10: the bundle bar (and the EXTRA bundle discounts) are gone; a free-shipping bar takes its place (part 4);
   - Whop visitors also get the second door "Pay via Revolut instead" under the drawer's checkout button (#4).
   Original header follows.
   Thighrise cart drawer extras (Essential Cart Drawer), operator 07-10 late:
   1. (09-10: trust points and "Have a code?" removed, checkout shows both; code row hidden in tr-bc.css.)
   (15-10, operator: the credit text says plainly that there is NOTHING to do, linked to the checkout email automatically,
   no sign-in; checking out fast matters most.)
   2. ONE credit line under the subtotal, right above "Secure checkout": "You earn $9.59 in store credit for your next
      order · 12¢ back for every $1 (i)". Every order earns RATE of its subtotal (after the bundle discount, without shipping
      protection) for the next one: retention + email, NOT an AOV push (no "add $X more"; the bundle bar does AOV).
      Issued right after payment by agents/wallet-credit.mjs as native Shopify store credit (operator 07-10 night: claimed
      through the customer account). RATE must match that agent + the FAQ. Signed-in customer with a balance sees it
      here; Shopify offers it at checkout. Data: snippets/tr-wallet-data.liquid.
   4. Free-shipping bar at the top of the drawer (Sableau 15-10). Styles: tr-bc.css. */
(function () {
  var RATE = (window.TR_WALLET && window.TR_WALLET.rate) || 0.12;
  // Multilingual (14-10): strings come from window.SB_T (snippets/sb-i18n.liquid); English fallback. ROOT keeps /de/, /fr/ … on links.
  function T(k, f) { return (window.SB_T && window.SB_T[k]) || f; }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var E = function (n) { return '[data-essential-cart-element="' + n + '"]'; };
  var subtotal = 0, timer = null;
  var W = window.TR_WALLET || {};
  function earn() { return Math.round(subtotal * RATE * 100) / 100; }
  // cents in the visitor's currency; the minimum order is set in EUR and converted with Shopify's rate
  function money(c) { return window.trMoney ? window.trMoney(c) : (c / 100).toFixed(2); }
  // 23-10 late operator: credit amounts carry "€" (EUR is bare in the store format, theme.liquid trMoney); the checkout button does not.
  function eur(t) { return window.Shopify && Shopify.currency && Shopify.currency.active === 'EUR' && t.indexOf('€') < 0 ? '€' + t : t; }
  // "€0,12 back for every €1" / "0,12 kr back for every 1 kr": the same 12 % in every currency
  function perUnit() { return money(RATE * 100) + ' ' + T('back_for_every', 'back for every') + ' ' + money(100).replace(/[.,]00(?=\D*$)/, ''); }

  // 3. Small credit line right above "Secure checkout" with an (i): tapping it opens a short explanation in place (operator 07-10).
  var ccOpen = false;
  function checkoutCredit() {
    var w = document.querySelector(E('checkout-button-wrapper'));
    if (!w) return;
    var el = w.previousElementSibling;
    if (!el || !el.classList.contains('tr-cc')) {
      document.querySelectorAll('.tr-cc').forEach(function (o) { o.remove(); });
      el = document.createElement('div');
      el.className = 'tr-cc';
      el.innerHTML = '<div class="tr-cc__row"><span class="tr-cc__t"></span><button type="button" class="tr-cc__i" aria-expanded="false" aria-label="' + T('cc_how', 'How store credit works') + '">i</button></div>' +
        '<div class="tr-cc__pop" hidden>' + T('cc_pop1', "<b>You don't need to do anything.</b> You get <b>[x]</b> you spend as store credit for your next order. It is linked automatically to the email you check out with: no account, no sign-in. We email you when it's ready, with a link to use it.").replace('[x]', perUnit()) + ' ' + T('cc_pop2', 'Valid for 90 days. No cash value.') + '</div>';
      el.querySelector('.tr-cc__i').addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ccOpen = !ccOpen; el.querySelector('.tr-cc__pop').hidden = !ccOpen; this.setAttribute('aria-expanded', ccOpen);
      });
      w.parentNode.insertBefore(el, w);
    }
    altDoor(w);
    el.querySelector('.tr-cc__pop').hidden = !ccOpen;
    var bal = +W.balance || 0;   // signed-in customer's store credit: payment-route sends them to the Shopify checkout, where it is applied
    var t = (bal > 0 ? '<span class="tr-cc__bal">' + T('cc_bal', 'Your <b>[x]</b> store credit is ready: tick "Apply store credit" at checkout.').replace('[x]', eur(money(bal))) + '</span><br>' : '') + T('cc_earn', 'You earn <b>[x]</b> store credit for your next order').replace('[x]', eur(money(earn() * 100))) + ' <span class="tr-cc__auto">· ' + T('cc_auto', 'nothing to do') + '</span>';  // 23-10 late operator: "nothing to do" back (short), so nobody stops to claim it
    var tt = el.querySelector('.tr-cc__t');
    if (tt.innerHTML !== t) tt.innerHTML = t;
  }

  // Second door for Whop visitors (#4), same as the /cart page (snippets/cart-summary.liquid): a <button>, no /checkout href
  // and none of the checkout selectors, so the Lasso script leaves it alone; pointerup, so a scrolling thumb never fires it.
  function altDoor(w) {
    if (W.route !== 'whop' || (w.nextElementSibling && w.nextElementSibling.classList.contains('tr-alt'))) return;
    document.querySelectorAll('.tr-alt').forEach(function (o) { o.remove(); });
    var p = document.createElement('p');
    p.className = 'tr-alt cart__alt-checkout';
    p.innerHTML = T('declined', 'Card declined?') + ' <button type="button" class="cart__alt-checkout-link">' + T('pay_revolut', 'Pay via Revolut') + '</button>';
    var go = function () { window.location.assign(ROOT + 'checkout?skip_shop_pay=true'); };
    var b = p.querySelector('button');
    b.addEventListener('pointerup', function (e) { if (e.button === 0) go(); });
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    w.parentNode.insertBefore(p, w.nextSibling);
  }

  // 4. Free-shipping bar (operator 15-10): replaces the bundle bar, the EXTRA bundle discounts and Essential's reward bar are off.
  // Threshold = EUR 79 (theme setting free_shipping_threshold) times Shopify's rate, rounded UP to a whole unit like
  // local-money.js does for the PDP and announcement bar, so no two surfaces disagree (20-10, code review #4).
  var RATE_FX = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  var FS = Math.ceil((+W.fs || 79) * RATE_FX) * 100, known = false;
  function fsBar() {
    var box = document.querySelector(E('cart-drawer-content'));
    if (!box || !known) return;
    // 19-10: Essential's own reward bar (free shipping + free beanie ladder) replaces this bar wherever it is enabled.
    if (box.querySelector(E('reward-goal-bar-wrapper'))) { var stale = box.querySelector('.tr-fs'); if (stale) stale.remove(); return; }
    var bar = box.querySelector('.tr-fs');
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'tr-fs';
      bar.innerHTML = '<p class="tr-fs__t"></p><div class="tr-fs__track"><i class="tr-fs__fill"></i></div>';
      box.insertBefore(bar, box.firstChild);
    }
    var left = Math.max(0, FS - subtotal * 100), done = left <= 0;
    var t = done ? T('fs_done', 'You unlocked <em>free shipping</em>!') : T('fs_left', 'Add <b>[x]</b> more for <em>free shipping</em>').replace('[x]', money(left));
    var tt = bar.querySelector('.tr-fs__t');
    if (tt.innerHTML !== t) tt.innerHTML = t;
    bar.toggleAttribute('data-done', done);
    bar.querySelector('.tr-fs__fill').style.width = Math.min(100, subtotal * 100 / FS * 100) + '%';
  }

  // 5. Reward unlocked (operator 20-10, option C): when Essential's reward bar shows one more ": unlocked" milestone than
  // before, that icon pops, a shine runs over the fill and the line fades in. No confetti, no library. Web Animations
  // only, so Essential's React re-render never strips a class mid-animation. The count lives in sessionStorage: a page
  // change or reload never replays it, removing an item lowers it so the next unlock plays again.
  var MS = E('reward-milestone') + '[aria-label$=": unlocked"]', EASE = 'cubic-bezier(.22,1,.36,1)';
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(k, v) { try { return v === undefined ? sessionStorage.getItem(k) : sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function rewards(bar) {
    var on = bar.querySelectorAll(MS), was = +store('sb-unlocked') || 0;
    if (on.length === was) return;
    store('sb-unlocked', on.length);
    if (on.length < was || calm || !Element.prototype.animate) return;
    for (var i = was; i < on.length; i++) {
      var ic = on[i].querySelector(E('reward-milestone-icon'));
      if (ic) ic.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)', offset: .35 }, { transform: 'scale(1)' }], { duration: 500, easing: EASE });
      if (ic) ic.animate([{ boxShadow: '0 0 0 0 rgba(0,0,0,.45)' }, { boxShadow: '0 0 0 16px rgba(0,0,0,0)' }], { duration: 900, easing: 'ease-out', composite: 'add' });
    }
    var fill = bar.querySelector(E('reward-progress-bar-fill'));
    if (fill) {
      var s = document.createElement('i');
      s.className = 'tr-shine';
      fill.appendChild(s);
      s.animate([{ transform: 'translateX(-100%)' }, { transform: 'translateX(250%)' }], { duration: 900, easing: 'ease-out' }).onfinish = function () { s.remove(); };
    }
    var p = bar.querySelector('p');
    if (p) p.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 350, easing: EASE });
  }

  // Header cart count (sections/tr-header.liquid prints it once on page load): follow every cart change (review 09-10 #8).
  function headerCount(n) {
    var a = document.querySelector('.trh__icons a[data-tr-cart]');
    if (!a) return;
    var s = a.querySelector('.trh__count');
    if (!n) { if (s) s.remove(); return; }
    if (!s) { s = document.createElement('span'); s.className = 'trh__count'; a.appendChild(s); }
    s.textContent = n;
  }

  function render() {
    document.querySelectorAll('.tr-wallet').forEach(function (o) { o.remove(); }); checkoutCredit(); fsBar();
    var rb = document.querySelector(E('reward-goal-bar-wrapper'));
    if (rb) rewards(rb);   // also after /cart.js: an unlock that only changes text never wakes the childList observer
  }

  function refresh() {
    fetch(ROOT + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
      // after the bundle discount, like the agent's currentSubtotalPrice; shipping protection (Essential order upsell) does not count
      var prot = (c.items || []).filter(function (i) { return i.product_type === 'Order Upsell'; }).reduce(function (a, i) { return a + i.final_line_price; }, 0);
      subtotal = Math.max(0, (c.total_price || 0) - prot) / 100;
      known = true; headerCount(c.item_count);
      render();
    }).catch(render);
  }
  // /cart.js only when the cart really changes (operator review 07-10): a cart add/change/update/clear response, or a
  // click inside the drawer (qty +/-, remove). Drawer re-renders without a cart change only re-draw our blocks.
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; refresh(); }, 400); }
  function ours(n) { return n && n.closest && n.closest('.sb-reservation, .tr-wallet, .tr-cc, .tr-fs'); }
  var CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var f0 = window.fetch;
  window.fetch = function (u) {
    var p = f0.apply(this, arguments);
    try { if (CART.test(String((u && u.url) || u))) p.then(schedule, schedule); } catch (e) {}   // never break the caller's fetch
    return p;
  };
  // 20-10 (code review #9): one check per frame, and a missing .tr-fs only counts when Essential's own reward bar is
  // absent. Before, that bar's presence made the check true on every mutation, so render() ran on each drawer re-render.
  var drawn = null, queued = false;
  function check() {
    queued = false;
    var w = document.querySelector(E('cart-drawer-content'));
    if (!w) return;
    var rb = w.querySelector(E('reward-goal-bar-wrapper'));
    if (rb) rewards(rb);
    var fsMissing = known && !w.querySelector('.tr-fs') && !w.querySelector(E('reward-goal-bar-wrapper'));
    if (w !== drawn || !document.querySelector('.tr-cc') || fsMissing) { drawn = w; render(); }
  }
  new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(check); } })
    .observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', function (e) {
    if (!ours(e.target) && e.target.closest && e.target.closest('[data-essential-cart-element]')) schedule();
  }, true);
  schedule();
})();
